// import { FranchiseProvider } from "./FranchiseContext";
// import { FranchiseItemProvider } from "./FranchiseItemContext";
import { OutletProvider } from "./OutletContext";

const Providers = ({ children }) => {
  return <>
    <OutletProvider>
      {/* <FranchiseProvider>
        <FranchiseItemProvider> */}
      {children}
      {/* </FranchiseItemProvider>
      </FranchiseProvider> */}
    </OutletProvider>
  </>
};

export default Providers;
